import React from 'react';
import { css, StyleSheet } from 'aphrodite';

import { AppTheme } from '../../../../styles/AppTheme';

export function AutomationNodeHeader(props) {
  return (
    <div className={css(Styles.header)}>
      <span className={css(Styles.iconTile)}>
        <i className={'material-icons-outlined ' + css(Styles.icon)}>{props.icon}</i>
      </span>
      <span className={css(Styles.title)}>{props.title}</span>
      {props.menu}
    </div>
  );
}

const Styles = StyleSheet.create({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 6px 8px 10px',
    backgroundColor: AppTheme.secondaryBg,
    borderBottom: '1px solid ' + AppTheme.borderColor,
    borderTopLeftRadius: AppTheme.borderRadius,
    borderTopRightRadius: AppTheme.borderRadius,
  },
  iconTile: {
    width: 22,
    height: 22,
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 auto',
    backgroundColor: '#F3F4F6',
  },
  icon: {
    fontSize: 14,
    lineHeight: 1,
    color: AppTheme.primaryColor,
  },
  title: {
    fontSize: 13,
    fontWeight: 600,
    color: '#222222',
    minWidth: 0,
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});
